var PsrProfileSelect = (function() {
    var cachedDOM = {};

    function cleanOptions() {
        cachedDOM.$select.empty();
    }

    return {
        init: function() {
            cachedDOM.$select = $("#profileID");
            cachedDOM.$editBtn = $("#profile-edit-btn");
            cachedDOM.$selectBtn = $("#profile-select-btn");
            cachedDOM.optionButtonsWrapper = $(
                '[data-name="profile-select"] .form-profile__list-option'
            );

            PsrProfileSelect.disableBtns();
            PsrProfileSelect.events();
        },

        events: function() {
            cachedDOM.$select.on("change", function(event) {
                var selectedValue = event.target.value;

                if (selectedValue) {
                    return PsrProfileSelect.enableBtns();
                }

                return PsrProfileSelect.disableBtns();
            });

            if (PsrHelpers.isIOS()) {
                cachedDOM.$select.on("click", function() {
                    cachedDOM.optionButtonsWrapper.css({
                        "pointer-events": "none"
                    });
                });

                cachedDOM.$select.on("blur", function() {
                    cachedDOM.optionButtonsWrapper.css({
                        "pointer-events": "auto"
                    });
                });
            }
        },

        enableBtns: function() {
            cachedDOM.$editBtn.removeClass("is-disable");
            cachedDOM.$selectBtn.removeClass("is-disable");
        },

        disableBtns: function() {
            cachedDOM.$editBtn.addClass("is-disable");
            cachedDOM.$selectBtn.addClass("is-disable");
        },

        populateSelect: function(profiles, selectedProfile) {
            cleanOptions();

            cachedDOM.$select.append(
                "<option value=''>Pessoa a ser analisada</option>"
            );

            profiles.map(function(profile) {
                var $option = $("<option>");
                var optionText =
                    profile.ProfileName +
                    " - " +
                    PsrHelpers.yyyymmddToDateFormat(profile.BirthDate);

                $option.val(profile.ProfileID).text(optionText);

                cachedDOM.$select.append($option);
            });

            if (selectedProfile) {
                cachedDOM.$select.val(selectedProfile);
            }

            cachedDOM.$select.trigger("change");
        },

        getSelectedProfileId: function() {
            return cachedDOM.$select.val();
        }
    };
})();
